import { get } from 'lodash'
import { createSelector } from 'reselect'

import { NO_CLINICIAN_DROPDOWN_VALUE } from 'src/constants'
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

const telehealth = (state = {}) => get(state, ['actions', 'telehealth'], {})

export const scheduledItems$ = createSelector(
  telehealth,
  ({ scheduledItems }) => scheduledItems
)

export const scheduledItemsLoading$ = createSelector(
  telehealth,
  ({ scheduledItemsLoading }) => scheduledItemsLoading
)

export const createCallLoading$ = createSelector(
  telehealth,
  ({ createCallLoading }) => createCallLoading
)

export const clinicianUsers$ = createSelector(
  telehealth,
  ({ clinicianUsers }) => clinicianUsers
)

export const filteredActiveClinicianUsers$ = createSelector(
  clinicianUsers$,
  (clinicianUsers = []) => clinicianUsers.filter(({ enabled }) => enabled)
)

export const clinicianUsersDropdown$ = createSelector(
  clinicianUsers$,
  (clinicianUsers = []) =>
    clinicianUsers.map((item, key) => ({
      ...item,
      key,
      title: item.fullName,
      label: item.fullName,
      value: item.uuid
    }))
)

export const clinicianUsersWithAll$ = createSelector(
  clinicianUsers$,
  (clinicianUsers = []) => addAllValue(clinicianUsers, true)
)

export const clinicianUsersWithAllAndNoClinician$ = createSelector(
  clinicianUsers$,
  (clinicianUsers = []) =>
    addAllValue([...clinicianUsers, NO_CLINICIAN_DROPDOWN_VALUE], true)
)

export const clinicianUsersWithAllAndNoClinicianV5$ = createSelector(
  clinicianUsers$,
  (clinicianUsers = []) =>
    addAllValueV5({ list: [...clinicianUsers, NO_CLINICIAN_DROPDOWN_VALUE] })
)

export const waitingRoomCount$ = createSelector(
  telehealth,
  ({ waitingRoomCount }) => waitingRoomCount
)

export const patientsListWithDevice$ = createSelector(
  telehealth,
  ({ patientsListWithDevice }) => patientsListWithDevice
)

export const isModalVisible$ = createSelector(
  telehealth,
  ({ isModalVisible }) => isModalVisible
)

export const isSchedulerModalVisible$ = createSelector(
  telehealth,
  ({ isSchedulerModalVisible }) => isSchedulerModalVisible
)
